<template>
    <div :class="['dimmer border-top' , loading ?  'active' : '']">
        <div class="loader"></div>
        <div class="dimmer-content">
            <div class="card">
                <div class="card-content px-0">
                    <div class="modal-header d-flex align-items-center">
                        <h3 class="text-4 pt-3 mt-n2 font-weight-400 d-flex align-items-center">
                            <strong> {{ biller.name }}</strong>
                        </h3>

                    </div>
                    <div class="p-4">
                        <div>
                            <div class="row">
                                <div class="row div col-12 mb-3">
                                    <img alt=""
                                         class="img-fluid w-50 m-auto "
                                         :src="biller.display_image || biller.image"
                                         />
                                </div>
                                <div class="col-12 col-sm-6">
                                    <div class="form-group">
                                        <label>Category</label>
                                        <div><strong>{{ biller.category }}</strong></div>
                                    </div>
                                </div>
                                <div class="col-12 col-sm-6">
                                    <div class="form-group">
                                        <label>Created</label>
                                        <div><strong>{{ biller.created_at }}</strong></div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12 col-sm-6">
                                    <div class="form-group">
                                        <label>Name</label>
                                        <div><strong>{{ biller.name }}</strong></div>
                                    </div>
                                </div>
                                <div class="col-12 col-sm-6">
                                    <div class="form-group">
                                        <label>Description</label>
                                        <div><strong>{{ biller.description }}</strong></div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12 col-sm-6">
                                    <div class="form-group">
                                        <label>Status</label>
                                        <div><strong>{{ biller.status }}</strong></div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: "Index",
    data() {
        return {
            loading: false,
            model: {

            },
            biller:{},
        };
    },

    mounted() {
        this.init();
    },

    methods: {

        action(action) {
            this.loading = true;
            window.axios.get(`/business/users/${this.$route.params.id}/update/${action}`).then((response) => {
                this.model = response.data.body.model;
                this.loading = false;
            });
        },

        init() {
            this.loading = true;
            window.axios.get(`/business/payments/${this.$route.params.id}/api/view`).then((response) => {
                this.model = response.data.body.model;
                this.biller = this.model.biller
                this.loading = false;
            });
        },

    }
}
</script>

<style scoped>

</style>
